import React from "react";
import { Card, DataTable, Text } from "@shopify/polaris";
import { PAGE_SIZE } from "../../constants/common-constants";

const ReportTable = ({ users, currentPage, setCurrentPage }) => {
  function capitalizeEachWord(str) {
    return str
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  }
  const rows = users.map((user) => [
    capitalizeEachWord(user.name),
    user.email,
    user.contactNumber,
    capitalizeEachWord(user.city),
    user.orderCount,
    `₹${user.lifetimeSpending.toFixed(2)}`, // Format spending to 2 decimals
    new Date(user.latestOrderDate).toLocaleDateString(), // Format date
  ]);

  return (
    <Card>
      <DataTable
        hideScrollIndicator
        columnContentTypes={[
          "text",
          "text",
          "text",
          "text",
          "text",
          "text",
          "text",
          "text",
        ]}
        headings={[
          <Text variant="headingSm">Customer Name</Text>,
          <Text variant="headingSm">Email</Text>,
          <Text variant="headingSm">Phone</Text>,
          <Text variant="headingSm">City</Text>,
          <Text variant="headingSm">Order Count</Text>,
          <Text variant="headingSm">Lifetime Spending</Text>,
          <Text variant="headingSm">Last Ordered At</Text>,
        ]}
        rows={rows}
        pagination={{
          hasNext: users.length >= PAGE_SIZE,
          onNext: () => {
            setCurrentPage(currentPage + 1);
          },
          onPrevious: () => {
            if (currentPage > 1) {
              setCurrentPage(currentPage - 1);
            }
          },
          hasPrevious: currentPage > 1,
        }}
      />
    </Card>
  );
};

export default ReportTable;
